import React, { useState } from 'react'
import MyButton from '../../../UI/form/MyButton'
import { responseError } from '../../../../helpers/response/ResponseHelper'
import ResultItem from './ResultItem'
import PackResultList from './PackResultList'
import { createPackAPI } from '../../../../api/pack/packAPI'
import PackResultCreated from '../resultCreated/PackResultCreated'

const PackResult = ({ orderIdCrm, resultCheck }) => {

    const [loading, setLoading] = useState(false)
    const [result, setResult] = useState('')
    const [error, setError] = useState('')

    const create = () => {
        setError('')
        setResult('')
        setLoading(true)
        createPackAPI({
            keyCrmOrderNumber: orderIdCrm
        }).then(data => {
            setResult(data)
            setLoading(false)
		}).catch(e => {
            setError(responseError(e))
            setLoading(false)
		})
    }

  return (
    <div>
        {
            result ?
                <PackResultCreated 
                    result={result}
                    orderIdCrm={orderIdCrm}
                />
            : ''
        }
        {
            orderIdCrm ?
                !result ?
                    <>
                        <PackResultList 
                            orderIdCrm={orderIdCrm}
                            resultCheck={resultCheck}
                        />
                        <MyButton
                            size='md'
                            onClick={create}
                            disabled={loading ? true : false}
                        >
                            Створити партію
                        </MyButton>
                    </>
                : ''
            : ''
        }
        
    </div>
  )
}

export default PackResult